/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

export class OsModel {
   public prefix: string = "download_rich_client_";
   public os: string = "unknown";
   public mIsWin32: boolean = false;
   public mIsWin64: boolean = false;
   public mIsWinMobile: boolean = false;
   public mIsLinux32: boolean = false;
   public mIsLinux64: boolean = false;
   public mIsMacOS: boolean = false;
   public mIsIOS: boolean = false;
   public mIsAndroid: boolean = false;
   public mIsChromeOS: boolean = false;
   public osNames: {
      win32: string;
      win64: string;
      winmobile: string;
      linux32: string;
      linux64: string;
      mac: string;
      android: string;
      ios: string;
      chromeos: string;
      unknown: string;
   };
   public osLiteral: string;

   constructor() {
      /*
       * Localization Map
       *   return the local key of the respective OS:
       *
       * win32 - os_win32
       * win64 - os_win64
       * winphone - os_winphone
       * linux32 - os_linux32
       * linux64 - os_linux64
       * mac - os_mac
       * android - os_android
       * ios - os_ios
       * chromeos - os_chromeos
       * unknown - os_unknown
       */
      this.osNames = {
         win32: "os_win32",
         win64: "os_win64",
         winmobile: "os_winmobile",
         linux32: "os_linux32",
         linux64: "os_linux64",
         mac: "os_mac",
         android: "os_android",
         ios: "os_ios",
         chromeos: "os_chromeos",
         unknown: "os_unknown"
      };
      this.osLiteral = "";
   }

   public getOsLiteral = (platform: string): string => {
      return this.prefix + (this.osNames[platform] || this.osNames.unknown);
   };

   public detectOS = (platform: string) => {
      this.os = platform || "unknown";

      switch (this.os) {
         case "win32":
            this.mIsWin32 = true;
            break;
         case "win64":
            this.mIsWin64 = true;
            break;
         case "winmobile":
            this.mIsWinMobile = true;
            break;
         case "linux32":
            this.mIsLinux32 = true;
            break;
         case "linux64":
            this.mIsLinux64 = true;
            break;
         case "mac":
            this.mIsMacOS = true;
            break;
         case "android":
            this.mIsAndroid = true;
            break;
         case "ios":
            this.mIsIOS = true;
            break;
         case "chromeos":
            this.mIsChromeOS = true;
            break;
         default:
            break;
      }
   };
}
